/**
 * Duration formatting shared by the time log and the live timer.
 */

function pad(n: number): string {
  return n < 10 ? `0${n}` : `${n}`;
}

/**
 * Compact human duration for recorded entries: "1h 30m", "5m", "<1m".
 * Drops a zero hour and never returns an empty string.
 */
export function formatDuration(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  if (s < 60) return '<1m';
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const parts: string[] = [];
  if (h > 0) parts.push(`${h}h`);
  if (m > 0) parts.push(`${m}m`);
  return parts.join(' ');
}

/**
 * Stopwatch display for a running timer: "4:07" or "1:04:07".
 */
export function formatStopwatch(totalSeconds: number): string {
  const s = Math.max(0, Math.floor(totalSeconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${m}:${pad(sec)}`;
}
